class MessagesController < ApplicationController
  def index
    @messages = Message.order(created_at: :asc)
    @message = Message.new
  end

  def create
    @message = Message.new(message_params)
    if @message.save
      # Turbo Stream handles the response - just acknowledge
      respond_to do |format|
        format.turbo_stream
        format.html { redirect_to messages_path }
      end
    else
      redirect_to messages_path, alert: "Could not send message."
    end
  end

  def destroy
    @message = Message.find(params[:id])
    @message.destroy
    respond_to do |format|
      format.turbo_stream
      format.html { redirect_to messages_path }
    end
  end

  private

  def message_params
    params.require(:message).permit(:username, :body)
  end
end
